import { CreatorsTable, CreatorsTableSkeleton } from "@/components/creators-table";
import { useAnalyticsBarStore, useCreatorsStore } from "@/stores";
import AnalyticsBar from "./AnalyticsBar";
import { useParams } from "react-router-dom";

export default function CreatorsTab() {
  // Get creators and actions from the store
  const {
    creators,
    isLoading: creatorsLoading,
    setCreators,
  } = useCreatorsStore();

  // Get campaign ID from route params to use as key for table remounting
  const { campaign_id } = useParams();

  // Toggled by the chevron left of the campaign tabs (CampaignPage header).
  const { showAnalyticsBar } = useAnalyticsBarStore();

  if (creatorsLoading && creators.length === 0) {
    return (
      <div className="w-full h-full">
        <CreatorsTableSkeleton />
      </div>
    );
  }

  return (
    // Flat inbox-tab layout: the table region is full-bleed (no outer gap,
    // no rounding — borders separate everything); only the AnalyticsBar
    // keeps breathing room above it.
    <div className="w-full h-full flex flex-col">
      {showAnalyticsBar && (
        <div className="">
          <AnalyticsBar />
        </div>
      )}
      <div className="flex-1 min-h-0">
        <CreatorsTable key={campaign_id} data={creators} setData={setCreators} />
      </div>
    </div>
  );
}
